import { getSidebarMenu } from "@/lib/drupal/get-menus.server"
import { DrupalNodeBasicPage, DrupalNodeRelease } from "@/types"
import { DrupalMenuLinkContent } from "next-drupal"
import Link from "next/link"

export const InThisSection = async ({resource, version}: {
  resource: DrupalNodeBasicPage | DrupalNodeRelease
  version?: string
}) => {
  if (resource.type == 'node--release') {
    return <></>
  }

  const product = resource.field_product
  const productCurrentVersion = product.field_current_version?.name
  const menu = await getSidebarMenu(product.field_menu.resourceIdObjMeta.drupal_internal__target_id, version ?? productCurrentVersion)

  function findMenuItem(links: DrupalMenuLinkContent[]):null | DrupalMenuLinkContent {
    return links.reduce((p,c) => {
      if (p) {
        return p
      }
      if (c.route.name != 'entity.node.canonical') {
        return null;
      }
      if (c.route.parameters.node == resource.drupal_internal__nid) {
        return c
      }
      if (c.items) {
        return findMenuItem(c.items)
      }
      return null
    }, null as null | DrupalMenuLinkContent)
  }

  const pageMenuItem = findMenuItem(menu)

  if (!pageMenuItem) {
    return <></>
  }

  if (!pageMenuItem.items) {
    return <></>
  }

  return <>
    <h2 id="in-this-section" className="font-medium text-lg mt-4 mb-2">In this section</h2>
    <ul className="flex flex-col gap-2">
      {pageMenuItem.items.map(link => (
        <li key={link.id}><Link className="text-blue-800 p-2 hover:bg-gray-500 block rounded hover:text-black" href={link.url}>{link.title}</Link></li>
      ))}
    </ul>
  </>
}